import DescriptionItem from './descriptions-item';
export type { DescriptionItemProps } from './descriptions-item';

export default DescriptionItem;
